import BasicText from "../components/react-bricks/BasicText"
import Faq from "../components/react-bricks/Faq"
import Faqs from "../components/react-bricks/Faqs"
import { types } from "react-bricks/rsc"

const bricks: types.Theme[] = [
    {
        themeName: "LaVita Bricks",
        categories: [
            {
                categoryName: "Text",
                bricks: [BasicText],
            },
            {
                categoryName: "FAQ",
                bricks: [Faq, Faqs],
            },
        ],
    },
]

export default bricks
